import { cache, } from "@bracket/chainography/helpers";
import { keccak256, toHex,} from "viem";
import type { Config } from "wagmi";
import { multicall, } from "wagmi/actions";
import type { contract, } from "./contract";



export async function caller<T = unknown>( config: Config, call: ReturnType<typeof contract>, ): Promise<[ T, Error ]> {

	if(!call) {
		throw new Error("@bracket/chainography/caller: call is required");
	}

	if(call.ttl) {

		const key = keccak256(toHex(JSON.stringify(call)));
		if(cache.has(key)) {
			const { since, value, ready, } = cache.get(key);
			if(ready) {
				if(Date.now() - since < call.ttl) {
					return [ value as T, null ];
				}
				cache.delete(key);
			}
		}
	
		const response = await multicall(config, { contracts: [call], });
		if(response.length) {
			const { result, status, error, } = response[0];
			if(status === "success") {
				cache.set(key, { since: Date.now(), value: result as T, ready: true, fetching: false, });
				return [ result as T, null ];
			}
			return [ null, error ];
		}
	
		return [ null, new Error("no result returned") ];

	}

	const response = await multicall(config, { contracts: [call], });
	if(response.length) {
		const { result, status, error, } = response[0];
		if(status === "success") {
			return [ result as T, null ];
		}
		return [ null, error ];
	}
	else {
		return [ null, new Error("no result returned") ];
	}

}
